/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IMyTaksRepository } from "@/interface/my-tasks";

const myTasksRepository: IMyTaksRepository = {
  /**
   * Função para buscar minhsas tarefas
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllMyTasks<T>(
    accessToken: string,
    page: number = 1,
    itemsPerPage: number = 10,
    searchItem: string = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.get(
      `remessas/minhas-tarefas?page=${page}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return customers?.data;
  },
  /**
   * Atualiza a situação de uma tarefa (remessa)
   * @param accessToken
   * @param idRemessa
   * @param situacao
   * @returns Promise<any | null>
   */
  async handleAtualizarTarefa<T>(
    accessToken: string,
    idRemessa: number,
    payload: any
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const response = await Instance.put(`remessas/${idRemessa}`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return response?.data;
  },
};

/**
 * EXPORTS
 */
export { myTasksRepository };
